import React from 'react';
import { Box, BoxSizeOptions } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { BodyText } from '..';

type NewBadgeProps = {
  size?: 'small' | 'large';
  borderRadius?: number;
  testID?: string;
  text?: string;
  paddingX?: BoxSizeOptions;
  paddingY?: BoxSizeOptions;
};

const NewBadge: React.FC<NewBadgeProps> = ({
  size = 'large',
  borderRadius = 6,
  testID = 'cip-new-badge',
  text = 'NEW!',
  paddingX = 4,
  paddingY = 4,
}) => (
  <Box
    paddingX={paddingX}
    paddingY={paddingY}
    color={colors.punch}
    testID={testID}
    borderRadius={borderRadius}
  >
    <BodyText
      weight="medium"
      color={colors.whiteWash}
      appearance={size === 'large' ? 'small' : 'smaller'}
    >
      {text}
    </BodyText>
  </Box>
);

export default NewBadge;
